export const state = () => ({
  ip: '',
});

export const mutations = {
  setIp(state, ip) {
    state.ip = ip;
  },
};
